import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  FreemiumBannerDesktopDefinition,
  FreemiumBannerDesktopPlatformProps,
} from '../FreemiumBannerDesktop.types';
import translationKeys from './constants';
import { freemiumBannerExperiments } from '../../common/constants';
import concatQueryParamsToUrl from '../../common/concatQueryParamsToUrl';

export const uiType = withCompInfo<any, FreemiumBannerDesktopDefinition>()(
  ['experiments'],
  ({ experiments }) => {
    const isNewLogo = isExperimentOpen(
      experiments,
      freemiumBannerExperiments.newBannerDesktop,
    );
    return isNewLogo ? 'FreemiumBannerDesktopNewLogo' : undefined;
  },
);

export const props = withCompInfo<
  FreemiumBannerDesktopPlatformProps,
  FreemiumBannerDesktopDefinition
>()(
  ['direction', 'metaSiteId', 'translate', 'experiments'],
  ({ direction, metaSiteId, translate, experiments }) => {
    const isNewLogo = isExperimentOpen(
      experiments,
      freemiumBannerExperiments.newBannerDesktop,
    );

    const bannerText = isNewLogo
      ? translate(
          translationKeys.NAMESPACE,
          translationKeys.MAIN_TEXT_KEY_NEW,
        ) || translationKeys.MAIN_TEXT_DEFAULT_NEW
      : translate(translationKeys.NAMESPACE, translationKeys.MAIN_TEXT_KEY) ||
        translationKeys.MAIN_TEXT_DEFAULT;

    const buttonText = isNewLogo
      ? translate(
          translationKeys.NAMESPACE,
          translationKeys.BUTTON_TEXT_KEY_NEW,
        ) || translationKeys.BUTTON_TEXT_DEFAULT_NEW
      : translate(translationKeys.NAMESPACE, translationKeys.BUTTON_TEXT_KEY) ||
        translationKeys.BUTTON_TEXT_DEFAULT;

    const href = isNewLogo
      ? translate(translationKeys.NAMESPACE, translationKeys.HREF_KEY_NEW) ||
        translationKeys.HREF_KEY_DEFAULT
      : translate(translationKeys.NAMESPACE, translationKeys.HREF_KEY_OLD) ||
        translationKeys.HREF_KEY_DEFAULT;

    const hrefAdsVersion = isNewLogo ? 'banner_2024' : 'white';

    const hrefWithQueryParams = concatQueryParamsToUrl(href, {
      orig_msid: metaSiteId,
      adsVersion: hrefAdsVersion,
    });

    return {
      useOverlay: false,
      direction,
      href: hrefWithQueryParams,
      classNames: [direction],
      translations: {
        bannerText,
        buttonText,
      },
    };
  },
);
export default createComponentMapperModel({
  props,
  uiType,
});
